export const newsletterCategory = {
  analysisAndOpinion: {
    entityId: "520771"
  },
  bizTechAndEconomy: {
    entityId: "500007"
  },
  chinaAndAsiaUnpacked: {
    entityId: "500004"
  },
  educationAndParents: {
    entityId: "520773"
  },
  essential: {
    entityId: "500003"
  },
  everythingHongKong: {
    entityId: "520772"
  },
  lifestyleAndWeekend: {
    entityId: "500006"
  },
  picturesFilmsAndVideo: {
    entityId: "500005"
  },
  sport: {
    entityId: "500008"
  },
  subscriberOnly: {
    entityId: "521523"
  }
};
export const newsletter = {
  abacus: {
    entityId: "327098",
    entityLabel: "ABACUS"
  },
  asia: {
    entityId: "323063",
    entityLabel: "THIS WEEK IN ASIA"
  },
  behindTheHeadlines: {
    entityId: "521375",
    entityLabel: "Behind the Headlines"
  },
  betterLife: {
    entityId: "502407",
    entityLabel: undefined
  },
  breakingNews: {
    entityId: "323473",
    entityLabel: "BREAKING NEWS ALERTS"
  },
  chinaAtAGlance: {
    entityId: "322279",
    entityLabel: "China at a Glance"
  },
  chinaBusinessBriefing: {
    entityId: "324680",
    entityLabel: undefined
  },
  coronavirus: {
    entityId: "505280",
    entityLabel: "CONFIRMED CORONAVIRUS CASES"
  },
  dailyPulse: {
    entityId: "517578",
    entityLabel: "Daily Pulse"
  },
  darkMatters: {
    entityId: "520815",
    entityLabel: "Dark Matters"
  },
  exclusive: {
    entityId: "324915",
    entityLabel: undefined
  },
  globalImpact: {
    entityId: "506194",
    entityLabel: "SCMP Global Impact Newsletter"
  },
  hkBusinessBriefing: {
    entityId: "324679",
    entityLabel: undefined
  },
  hongKongUpdate: {
    entityId: "510083",
    entityLabel: "Hong Kong Update"
  },
  hundredTopTable: {
    entityId: "519979",
    entityLabel: undefined
  },
  inPictures: {
    entityId: "324669",
    entityLabel: undefined
  },
  insideChinaTech: {
    entityId: "329707",
    // cspell: ignore INSIDECHINATECH
    entityLabel: "INSIDECHINATECH"
  },
  kPop: {
    entityId: "507747",
    entityLabel: undefined
  },
  lifeAndCulture: {
    entityId: "322280",
    entityLabel: undefined
  },
  listeningPost: {
    entityId: "511120",
    entityLabel: undefined
  },
  longReads: {
    entityId: "324615",
    entityLabel: undefined
  },
  lunar: {
    entityId: "501957",
    entityLabel: undefined
  },
  marketsToday: {
    entityId: "500264",
    entityLabel: undefined
  },
  martialArts: {
    entityId: "502648",
    entityLabel: undefined
  },
  myNews: {
    entityId: "521524"
  },
  opinion: {
    entityId: "323850",
    entityLabel: undefined
  },
  posties: {
    entityId: "516369",
    entityLabel: "SCMP Parents"
  },
  postMag: {
    entityId: "322743",
    entityLabel: "POST MAGAZINE"
  },
  racing: {
    entityId: "323665",
    entityLabel: "HK RACING"
  },
  scmpProperty: {
    entityId: "322281",
    entityLabel: undefined
  },
  scmpTodayHk: {
    entityId: "20916",
    entityLabel: "SCMP TODAY: HK EDITION"
  },
  scmpTodayInt: {
    entityId: "322277",
    entityLabel: "SCMP TODAY: INTL EDITION"
  },
  sportingWeekend: {
    entityId: "519808",
    entityLabel: undefined
  },
  style: {
    entityId: "322992",
    entityLabel: undefined
  },
  supportScmp1: {
    entityId: "506605",
    entityLabel: undefined
  },
  supportScmp2: {
    entityId: "506677",
    entityLabel: undefined
  },
  supportScmp3: {
    entityId: "506597",
    entityLabel: undefined
  },
  supportScmp4: {
    entityId: "506696",
    entityLabel: undefined
  },
  thisWeekInAsia: {
    entityId: "323063",
    entityLabel: undefined
  },
  usChinaTradeWar: {
    entityId: "330177",
    entityLabel: undefined
  },
  video: {
    entityId: "323511",
    entityLabel: undefined
  }
};
export const NEWSLETTER_BUNDLES = [{
  displayName: "Essential",
  newsletters: [newsletter.scmpTodayInt.entityId, newsletter.chinaAtAGlance.entityId, newsletter.breakingNews.entityId, newsletter.exclusive.entityId]
}, {
  displayName: "Everything Hong Kong",
  newsletters: [newsletter.scmpTodayHk.entityId, newsletter.hongKongUpdate.entityId, newsletter.lifeAndCulture.entityId, newsletter.hundredTopTable.entityId]
}, {
  displayName: "BizTech & Economy",
  newsletters: [newsletter.chinaBusinessBriefing.entityId, newsletter.insideChinaTech.entityId, newsletter.marketsToday.entityId, newsletter.breakingNews.entityId]
}, {
  displayName: "China & Asia Unpacked",
  newsletters: [newsletter.chinaAtAGlance.entityId, newsletter.thisWeekInAsia.entityId, newsletter.globalImpact.entityId, newsletter.breakingNews.entityId]
}, {
  displayName: "Lifestyle",
  newsletters: [newsletter.lifeAndCulture.entityId, newsletter.postMag.entityId, newsletter.hundredTopTable.entityId]
}, {
  displayName: "Analysis & Opinion",
  newsletters: [newsletter.globalImpact.entityId, newsletter.darkMatters.entityId, newsletter.opinion.entityId, newsletter.breakingNews.entityId]
}];